import type { ActionTypes } from '../../../../types/CIAM'

export const session = async (type: ActionTypes) =>
	window.myTSAccountProtection.getSessionToken(type)
